module.exports = __webpack_public_path__ + "static/media/flag-de.75dd2096.webp";